import { useConfigurableBuildersQuery } from '../graphql/ConfigurableBuilders'

export const useConfigurableBuilders = () => {
  const { data, ...state } = useConfigurableBuildersQuery()
  const { configurableBuilders = [] } = data || {}

  return {
    ...state,
    configurableBuilders,
  }
}
